import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { AppService } from 'src/app/app.service';
import { Permission } from 'src/app/models/permission.model';
import { EmailMarketingService } from './email-marketing.service';
import { Constants } from '../../shared/utils/constants';
import { map } from 'rxjs/operators';
import { EmailHistoryService } from '../email-history/email-history.service';
import { EmailCampaignProps } from '../email-history/email-history.model';
declare var nicEditor: any;
declare var $: any;

@Component({
  selector: 'fx-email-marketing',
  templateUrl: './email-marketing.component.html',
  styleUrls: ['./email-marketing.component.sass'],
})
export class EmailMarketingComponent implements OnInit, AfterViewInit {
  @ViewChild('form') form: NgForm;
  permission: Permission;
  previewData: any = { content: '', type: 'noreply' };
  emailTypes = Constants.EMAIL_TYPES;
  condition: any = { emailType: 'noreply', option: 0 };
  data = {
    keyword: '',
    userSpecific: '',
    content: '',
    subAll: '',
    country: 'all',
    campaign_name: '',
    accounts: {
      active_user: true,
      active_ib: false,
      without_deposit: false,
    },
  };
  campaignName = '';
  tabs = [
    {
      name: 'All Users under specific IB',
      key: 'all_user_specific_ib',
      active: true,
      label: 'All Users under specific IB',
    },
    {
      name: 'Condition',
      key: 'other',
      active: false,
      label: 'Condition',
    },

  ];
  currentTabActive = this.tabs[0];
  tabSelected: any = 'all_user_specific_ib';
  listPreview = [];
  pageInfo: any = {
    pageIndex: 1,
    pageSize: 10,
    totalRecord: 0,
  };
  editor: any;

  schedulerDate = '';
  campaignCreatedList: EmailCampaignProps[] = []
  selectedCampaign: any;
  minDate = new Date();
  maxContentLength = 5000;
  constructor(
    private appService: AppService,
    private service: EmailMarketingService,
    private readonly mailService: EmailHistoryService,
    private readonly elr: ElementRef<HTMLElement>
  ) {
    this.permission = this.appService.getCurrentPermission(location.pathname);
  }


  ngOnInit(): void {
    this.getCampaignList();
  }

  getCampaignList() {
    this.mailService.getCampaignHistory().pipe(
      map(e => e.data.campaigns),
    ).subscribe({
      next: (data) => {
        this.campaignCreatedList = data;
      }
    });
  }

  onChangeTab(event): void {
    this.currentTabActive = event;
    this.tabSelected = event.key;
    if (event.key === 'all_user_specific_ib') {
      this.initWys();
    }
    if (event.key === 'other') {
      this.initWysOther();
    }
  }

  searchEmail(event): void {
    if (event.keyCode === 13 || event === 'click') {
      this.pageInfo.pageIndex = 1;
      this.postPreviewEmailMarketing();
    }
  }

  private isEmailAddress(str): boolean {
    const pattern = /^[\w\-\+\.]+@([\w\-]+\.)+[\w\-]{2,4}$/;
    return pattern.test(str);
  }

  getEmailAddressListFormat() {
    return this.data.userSpecific.replace(/\r?\n/g, ',').split(',');
  }

  postPreviewEmailMarketing(): void {
    const listEmail = this.getEmailAddressListFormat();
    const listEmailRequest = [];
    listEmail.map((v) => {
      if (v !== undefined && this.isEmailAddress(v.trim())) {
        listEmailRequest.push(v.trim());
      }
    });
    if (listEmailRequest.length <= 0) {
      this.appService.showError(
        'Please enter correct Email address or check email syntax.'
      );
      return;
    }
    const body = {
      emails: listEmailRequest,
      page: this.pageInfo.pageIndex,
      page_size: this.pageInfo.pageSize,
      q: this.data.keyword.trim(),
      option: this.condition.option,
      type: 'ib'
    };
    this.service.preview(body).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.listPreview = res.data;
        this.pageInfo.totalRecord = res.paging.total;
        if (this.listPreview.length <= 0) {
          this.appService.showWarning('Email sending empty.');
        }
      }
    });
  }

  preview(): void {
    this.previewData = { content: '' };
    const listEmail = this.getEmailAddressListFormat();
    const listEmailRequest = [];
    listEmail.map((v: string) => {
      if (v !== undefined && this.isEmailAddress(v.trim())) {
        listEmailRequest.push(v.trim());
      }
    });
    if (listEmailRequest.length <= 0) {
      this.appService.showError('Please enter correct Email address or check email syntax.');
      return;
    }
    this.convertWysText();
    const content = $('#fill-content').text();
    if (!content || !content.trim()) {
      this.appService.showError('Please enter sending content.');
      return;
    }
    this.previewData = {
      emails: listEmailRequest,
      content,
    };
  }

  postSendEmailMarketing(): void {
    const list = this.getEmailAddressListFormat();
    const listEmailRequest = [];
    list.map((v) => {
      if (v !== undefined && this.isEmailAddress(v.trim())) {
        listEmailRequest.push(v.trim());
      }
    });
    if (listEmailRequest.length <= 0) {
      this.appService.showError('Please enter correct Email address or check email syntax.');
      return;
    }
    this.convertWysText();
    if (this.data.content?.length <= 0 || !this.data.content || this.data.content === '<div><br></div>') {
      return this.appService.showError('Please enter content.');
    }
    if(this.data.content?.length > this.maxContentLength) {
      return this.appService.showError(`Please enter content less than ${this.maxContentLength} symbols. Currently is ${this.data.content.length}`);
    }

    if (!this.data.subAll) {
      this.appService.showError('Please enter subject.');
      return;
    }
    if(this.campaignName.length === 0) {
      return this.appService.showError('Campaign Name is required.');
    }
    const body = {
      emails: listEmailRequest,
      text: this.data.content,
      subject: this.data.subAll,
      type_mail: this.condition.emailType,
      option: this.condition.option,
      type: this.tabSelected === 'all_user_specific_ib' ? 'ib' : 'condition',
      campaign_name: this.campaignName,
      ...((this.schedulerDate.length !== 0) && { time: new Date(this.schedulerDate).getTime() }),
    };
    this.service.sending(body).subscribe((res) => {
      if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
        this.appService.showSuccess('Sending success.');
        this.data.subAll = '';
        this.data.content = '';
        this.data.userSpecific = '';
        this.campaignName = '';
        this.listPreview = [];
        this.selectedCampaign = null;
        this.schedulerDate = null;
        this.form.resetForm({
          ddlEmailType: 'noreply',
          radioOption: 0,
          schedulerDate: '',
        })
        $('div.nicEdit-main').html('');
        this.getCampaignList();
      }
    });
  }

  import(data: string): void {
    this.data.userSpecific = data;
  }

  pageChanged(page: number): void {
    this.pageInfo.pageIndex = page;
    this.postPreviewEmailMarketing();
  }
  convertWysText(): void {
    if ($('#fill-content').text()) {
      this.data.content = `<div>${$('#fill-content').text()}</div>`;
    }
  }
  private initWys(): void {
    setTimeout(() => {
      try {
        this.editor = new nicEditor({ fullPanel: true }).panelInstance(
          'areaAll'
        );
        this.editor.addEvent('blur', function () {
          if (this.instanceById('areaAll')) {
            const text = this.instanceById('areaAll').getContent();
            $('#fill-content').text(text);
          }
        });
      } catch (e) {}
    }, 500);
  }
  private initWysOther(): void {
    setTimeout(() => {
      try {
        this.editor = new nicEditor({ fullPanel: true }).panelInstance(
          'areaOther'
        );
        this.editor.addEvent('blur', function () {
          if (this.instanceById('areaOther')) {
            const text = this.instanceById('areaOther').getContent();
            $('#fill-content-other').text(text);
          }
        });
      } catch (e) {}
    }, 500);
  }
  ngAfterViewInit(): void {
    this.initWys();
  }
}
